import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { getConfiguredLabel } from '../../common/commonHelper';
import { footer, svg } from '../../common/labelConstants';

export function Footer() {


    return <div className='footer_wrapper'>
            <div className='footer_top'>
            <Container>
                <Row>
                    <Col md={6}>
                        <div className='footer_logo'>
                        <span dangerouslySetInnerHTML={{ __html: getConfiguredLabel(svg, footer) }}></span>
                        </div>
                    </Col>
                        <Col md={6}>
                            <div className='footer_right'>
                                <ul>
                                    <li><a href="#">About Portal</a></li>
                                    <li><a href="#">Whats New</a></li>
                                    <li><a href="#">FAQs</a></li>
                                    <li><a href="#">Feedback</a></li>
                                </ul>
                            <p>Write to us @ <a href="#">Product@evalueserve.com</a></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='footer_bottom'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='copyright'>
                                <p>Copyright 2022. Evalueserve.com Pvt. Ltd, All right reserved.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
    </div>


}